import { useCookies } from 'vue3-cookies'

// The name the legacy notification used, so a reminder already skipped stays skipped.
function todayKey() {
  return `RunOutOfBalanceNotification_${new Date().toDateString().replaceAll(' ', '')}`
}

export function useLowBalanceDismissal() {
  const { cookies } = useCookies()

  const isDismissedToday = () => cookies.get(todayKey()) === 'true'
  const dismissToday = () => cookies.set(todayKey(), 'true')

  return { isDismissedToday, dismissToday }
}
